export { default } from './RichTextInputArea.js';
